import { renderDiscountImportantPopup } from 'components/Discount/func';
import { DESKTOP_MIN_WIDTH, METHOD_PAYTO } from 'constants';
import { FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME } from 'constants/fx';
import withLoadPaytoAccountsAgreementInitial from 'features/to/HOCs/payment/withLoadPaytoAccountsAgreementInitial';
import withPaymentMethodAutoSelect from 'features/to/HOCs/payment/withPaymentMethodAutoSelect';
import PaytoAccountsAgreement from 'features/to/components/payment/payto/PaytoAccountsAgreement';
import useFxAddTransaction from 'hooks/fx/useFxAddTransaction';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import useCommonStore from 'hooks/useCommonStore';
import useLang from 'hooks/useLang';
import { isArray } from 'lodash';
import React, { useState } from 'react';
import styled from 'styled-components';
import PaymentMethodsGrid from '../PaymentMethodsGrid';

const PaymentMethodsGridExt = withLoadPaytoAccountsAgreementInitial(
  withPaymentMethodAutoSelect(PaymentMethodsGrid)
);

const FxMakePayment = ({
  initialFormField,
  renderActionsButton,
  renderDiscountSection,
  information,
  setInformation,
  validation,
  setValidation,
  informationChangeBackup,
  setInformationChangeBackup,
  setOpenFxPaymentMethodOnChangePopup,
  paymentMethodCache,
}) => {
  const { t } = useLang();

  const [isOpenDiscountImportantPopup, setOpenDiscountImportantPopup] =
    useState(false);

  const { isUpdateTran, getPayLimitRanger } = useFxAddTransaction();
  const {
    paymentMethodName,
    setPaymentMethod,
    discountDetails,
    addTransactionInformation,
    isPaytoBlocked,
    getPaymentAmountLimit,
  } = useFxFormAddTransactionStore();
  const { paymentMethod: paymentStore } = addTransactionInformation || {};

  const { paytoAccountsAgreement } = useCommonStore();

  const handleOnClickDiscountImportantPopup = () => {
    if (informationChangeBackup) {
      setInformation(informationChangeBackup);

      const newPaymentMethod = {
        ...paymentStore,
        ...informationChangeBackup,
        discountsAvailable: [],
        discountsInactive: [],
        discountApplied: null,
      };
      setPaymentMethod(newPaymentMethod);

      setInformationChangeBackup(null);

      setValidation(initialFormField);
    }
  };
  const handleOnCloseDiscountImportantPopup = () => {
    setInformationChangeBackup(null);
  };

  const isPaymentMethodDisabled = (paymentMethodName) => {
    const payLimit = getPayLimitRanger()?.[paymentMethodName];
    const amountLimit = getPaymentAmountLimit();

    if (payLimit?.payLimitMax && amountLimit > payLimit?.payLimitMax)
      return {
        ...payLimit,
        amountLimit,
      };

    return false;
  };
  const checkPaymentMethodItemDisabled = (paymentMethod) => {
    if (paymentMethod === METHOD_PAYTO)
      return (
        (isArray(paytoAccountsAgreement) &&
          paytoAccountsAgreement?.some(
            (accountAgreement) => accountAgreement?.blocked
          )) ||
        isPaymentMethodDisabled(paymentMethod)
      );
    return isPaymentMethodDisabled(paymentMethod);
  };
  const renderPaytoAccountAgreement = () => {
    if (checkPaymentMethodItemDisabled(paymentMethodName)) return null;
    if (isPaytoBlocked) return null;
    return <PaytoAccountsAgreement validation={validation} />;
  };

  return (
    <>
      {isOpenDiscountImportantPopup &&
        renderDiscountImportantPopup({
          t,
          isOpen: isOpenDiscountImportantPopup,
          setOpen: setOpenDiscountImportantPopup,
          paymentMethod: paymentMethodName,
          onCloseExt: handleOnCloseDiscountImportantPopup,
          onClickExt: handleOnClickDiscountImportantPopup,
          contentReplace:
            isUpdateTran &&
            t('discount_check_invalid_desc_3', {
              discountPaymentMethod: discountDetails?.paymentMethod,
              paymentMethodSelected:
                informationChangeBackup?.[
                  FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME
                ],
            }),
        })}

      <FxMakePaymentStyled>
        <PaymentMethodsGridExt
          information={information}
          setInformation={setInformation}
          validation={validation}
          setValidation={setValidation}
          informationChangeBackup={informationChangeBackup}
          setInformationChangeBackup={setInformationChangeBackup}
          setOpenDiscountImportantPopup={setOpenDiscountImportantPopup}
          paymentMethodCache={paymentMethodCache}
          setOpenFxPaymentMethodOnChangePopup={
            setOpenFxPaymentMethodOnChangePopup
          }
          isSelectRequired={validation[FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME]}
          checkPaymentMethodItemDisabled={checkPaymentMethodItemDisabled}
        />
        {renderPaytoAccountAgreement()}
        {renderDiscountSection()}
        {renderActionsButton()}
      </FxMakePaymentStyled>
    </>
  );
};
const FxMakePaymentStyled = styled.div`
  display: inline-block;
  width: 100%;
  margin-top: -8px;
  padding-inline: 0px;
  padding-bottom: 254px;
  background: var(--ds-c-white);

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: 100%;
    margin-top: 0px;
    padding-inline: 0px;
    padding-bottom: unset;
  }
`;

export default FxMakePayment;
